{
	"success": "Success!",
	"error": "Error!",
	"warning": "Attention!"
}
